import api from './api';
import { DELETE, GET, POST, spamWordsRoutes } from '../constants/api';

export const getAllSpamWords = () =>
  api({
    method: GET,
    url: spamWordsRoutes.GET_ALL_SPAM_WORDS,
  });

export const createSpamWord = data => {
  return api({
    method: POST,
    url: spamWordsRoutes.CREATE_SPAM_WORD,
    data,
  });
};

export const deleteSpamWord = id =>
  api({
    method: DELETE,
    url: spamWordsRoutes.DELETE_SPAM_WORD(id),
    data: { id },
  });
